import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {defaultLocale, Locale} from '../../models/locale';
import {Promotion} from '../../models/promotion';
import {AdminPromotionService} from '../../shared/services/admin-promotion.service';

@Component({
    selector: 'app-preview-promotion',
    templateUrl: './preview-promotion.component.html',
    styleUrls: ['./preview-promotion.component.scss'],
})
export class PreviewPromotionComponent implements OnInit {
    id: string;
    promotion: Promotion;
    error: any;
    isLoading = false;

    constructor(private adminPromotionService: AdminPromotionService, private route: ActivatedRoute,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('promotionId') || environment.promotionId;
        const {authToken, brandId} = this.route.snapshot.queryParams;
        const locale = this.route.snapshot.queryParams.locale as Locale || defaultLocale;
        this.translateService.use(locale);
        this.loadData(authToken, brandId, locale).then();
    }

    private async loadData(authToken: string, brandId: string, locale: string): Promise<void> {
        try {
            this.error = null;
            this.isLoading = true;
            this.promotion = await this.adminPromotionService.getPromotion(this.id, authToken, brandId, locale);
        } catch (e) {
            this.error = e;
            this.error.error.message = this.translateService.instant('errorMessages.expiredSession');
        } finally {
            this.isLoading = false;
        }
    }
}
